import { Box } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import type { Project } from "../../lib/brain-api";
import { brainTokens } from "../../design/brainTheme";
import { SectionCard, StatusPill, statusTone, Icon } from "../../mui";

const c = brainTokens.color;

export function CustomerProjectsTabMui({ projects }: { projects: Project[] }) {
  if (!projects.length) {
    return (
      <SectionCard>
        <Box sx={{ fontSize: 13.5, color: c.muted2, textAlign: "center", py: 4 }}>No projects for this customer yet.</Box>
      </SectionCard>
    );
  }
  return (
    <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "14px" }}>
      {projects.map((p) => {
        const pct = p.completeness ?? 0;
        return (
          <Box
            key={p.projectId}
            component={RouterLink}
            to={`/projects/${p.projectId}`}
            sx={{
              display: "block",
              textDecoration: "none",
              background: "#fff",
              border: `1px solid ${c.border}`,
              borderRadius: "8px",
              p: "20px 22px",
              "&:hover": { borderColor: "#c7d6d6" },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: "16px", gap: 1 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: "10px", minWidth: 0 }}>
                <Box sx={{ color: c.tealInk2, display: "flex", flex: "none" }}>
                  <Icon name="hex" size={16} stroke={1.7} />
                </Box>
                <Box sx={{ fontSize: 15, fontWeight: 600, color: c.ink, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {p.name}
                </Box>
              </Box>
              <StatusPill tone={statusTone(p.status)} label={p.status} dot />
            </Box>
            <Box sx={{ height: 6, borderRadius: "999px", background: "#eef1f3", overflow: "hidden", mb: "10px" }}>
              <Box sx={{ height: "100%", width: `${Math.min(100, Math.max(0, pct))}%`, background: c.tealInk2, borderRadius: "999px" }} />
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: 12.5, color: c.muted2 }}>
              <span>{Math.round(pct)}% complete</span>
              <Box component="span" sx={{ fontFamily: brainTokens.font.mono }}>
                {p.owner ?? p.assignee ?? "—"}
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}
